<script setup></script>
<template>
  <RouterView></RouterView>
</template>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
.swal2-title{ line-height: 1.25; }
:root {
  --bs-font-sans-serif:
    'Inter', -apple-system, blinkmacsystemfont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  --bs-root-font-size: 15px;
  /* --bs-body-font-size: .9275rem; */
}
</style>
